// extracted by mini-css-extract-plugin
export default {"characterName":"styles_characterName__2x8wQ"};